import { useEffect, useMemo, useState } from "react";
import { Badge, Card, CardText, CardTitle } from "reactstrap";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch } from "react-redux";
import { setPageNumber } from "../../../store/job/action";
import "./JobList.scss";

export default function JobList(props) {
  const {
    jobListRaw,
    selectedJob,
    pageNumber,
    isLastPage,
    handleJobSelect,
  } = props;
  const dispatch = useDispatch();
  const [jobFound, setJobFound] = useState(false);
  // Parse jobListRaw to JSON object
  const jobList = useMemo(
    () => jobListRaw.map((job) => JSON.parse(job.submissionData)),
    [jobListRaw]
  );
  
  // Handle next page
  function handleNextPage() {
    dispatch(setPageNumber(pageNumber + 1));
  }

  return (
    <InfiniteScroll
      className="d-flex flex-column gap-4 mt-1 mb-4 joblist-container"
      dataLength={jobListRaw.length}
      next={handleNextPage}
      hasMore={!isLastPage}
      scrollableTarget="scrollableDiv"
    >
      {jobListRaw.map((job, jobIndex) => (
        <Card
          key={job.id}
          className={`mb-0 p-4 pointer ${
            selectedJob?.id === job.id && "border-cobaltblue"
          }`}
          onClick={() => handleJobSelect(job)}
        >
          <CardTitle className="mb-1 fs-12">
            {jobList[jobIndex].jobId}
          </CardTitle>
          <CardTitle tag="h5">{jobList[jobIndex].jobTitle}</CardTitle>
          <CardText className="mb-4 color-slategray">
            <Badge className="me-2 badge-custom">
              {jobList[jobIndex].jobType.toUpperCase()}
            </Badge>
            Salary: {jobList[jobIndex].payrate}
          </CardText>
          <div className="d-flex align-items-center">
            <i className="las la-map-marker me-1" />
            <CardText className="color-slategray">
              {jobList[jobIndex].country}, {jobList[jobIndex].workLocation}
            </CardText>
          </div>
        </Card>
      ))}
    </InfiniteScroll>
  );
}
